/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ThemeOptions } from '@mui/material/styles';

export const fonts = (basePath: string): ThemeOptions => ({
	fonts: [
		{
			family: 'Open Sans',
			style: 'normal',
			display: 'swap',
			weight: 300,
			src: `url(${basePath}/fonts/OpenSans-Light.ttf) format("truetype")`,
			unicodeRange: 'U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F',
		},
		{
			family: 'Open Sans',
			style: 'normal',
			display: 'swap',
			weight: 400,
			src: `url(${basePath}/fonts/OpenSans-Regular.ttf) format("truetype")`,
			unicodeRange: 'U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F',
		},
		{
			family: 'Open Sans',
			style: 'normal',
			display: 'swap',
			weight: 500,
			src: `url(${basePath}/fonts/OpenSans-Medium.ttf) format("truetype")`,
			unicodeRange: 'U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F',
		},
		{
			family: 'Open Sans',
			style: 'normal',
			display: 'swap',
			weight: 600,
			src: `url(${basePath}/fonts/OpenSans-SemiBold.ttf) format("truetype")`,
			unicodeRange: 'U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F',
		},
		{
			family: 'Open Sans',
			style: 'normal',
			display: 'swap',
			weight: 700,
			src: `url(${basePath}/fonts/OpenSans-Bold.ttf) format("truetype")`,
			unicodeRange: 'U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F',
		},
		{
			family: 'Open Sans',
			style: 'normal',
			display: 'swap',
			weight: 800,
			src: `url(${basePath}/fonts/OpenSans-ExtraBold.ttf) format("truetype")`,
			unicodeRange: 'U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F',
		},
	],
});
